module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#40404C;} </style><path class=\"st0\" d=\"M1,1v14h7v2H5v2h10v-2h-3v-2h7V1H1z M17,11H3V3h14V11z\"></path></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/svg-inline-loader?removeSVGTagAttrs=false!./src/img/devices.svg
 ** module id = 1045
 ** module chunks = 0
 **/